import React from "react";
import {
  Button,
  TextField,
  Grid,
  Box,
  Divider,
  Dialog,
  DialogTitle,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

const AddProductBrick = ({
  openDialog,
  handleClose,
  register,
  handleSubmit,
  errors,
  onAddBrickSubmit,
  productFamilyList,
  formData,
  isUpdateButton,
  isEditMode,
  setIsUpdateButton,
  categoryList,
  onCategoryClick,
  diableFamilyDropdown,
  setValue
}) => {
  const { content } = productFamilyList;
  return (
    <>
      <Dialog open={openDialog} onClose={handleClose} fullWidth={1}
        maxWidth={"xs"}>
        <DialogTitle
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <b>{!isEditMode ? "Add Product Brick" : "Edit Product Brick"}</b>
            </div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12 } sx={{ p: 2 }}>
              <Box>
                <form>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="left"
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth>
                        <InputLabel
                          id="Select-Category-label"
                          sx={{ marginTop: "-6px" }}
                        >
                          Select Category
                        </InputLabel>
                        <Select
                          className="stepperFormInput"
                          label="Select Category"
                          name="categoryId"
                          fullWidth
                          size="small"
                          defaultValue={formData.categoryId}
                          autoComplete="off"
                          {...register("categoryId", { required: true })}
                          error={Boolean(errors?.categoryId)}
                          helperText={errors?.categoryId?.message}
                          onChange={() => setIsUpdateButton(false)}
                        >
                          {categoryList?.content &&
                            categoryList?.content.map((d) => {
                              return (
                                <MenuItem
                                  native
                                  key={d.categoryId}
                                  sx={{ width: "100%" }}
                                  value={d.categoryId}
                                  size="small"
                                  onClick={() =>
                                    onCategoryClick(
                                      d.categoryId,
                                      d.categoryName
                                    )
                                  }
                                >
                                  {d.categoryCode} - {d.categoryName}
                                </MenuItem>
                              );
                            })}
                        </Select>
                        <FormHelperText sx={{ color: "#d32f2f" }}>
                          {errors && errors?.categoryId?.message}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <FormControl fullWidth>
                        <InputLabel
                          id="Select-Category-label"
                          sx={{ marginTop: "-6px" }}
                        >
                          Select Product Family
                        </InputLabel>
                        <Select
                          className="stepperFormInput"
                          label="Select Product Family"
                          name="productCatFamilyMappingId"
                          fullWidth
                          size="small"
                          autoComplete="off"
                          {...register("productCatFamilyMappingId", {
                            required: true,
                          })}
                          disabled={!isEditMode && diableFamilyDropdown}
                          defaultValue={formData.productCatFamilyMappingId}    
                          error={Boolean(errors?.productCatFamilyMappingId)}
                          helperText={
                            errors?.productCatFamilyMappingId?.message
                          }
                          onChange={() => setIsUpdateButton(false)}
                        >
                          {content && content.length > 0 ? (
                            content.map((d) => {
                              return (
                                <MenuItem
                                  native
                                  key={d.productCatFamilyMappingId}
                                  sx={{ width: "100%" }}
                                  value={d.productCatFamilyMappingId}
                                  size="small"
                                >
                                  {d.productFamilyName}
                                </MenuItem>
                              );
                            })
                          ) : (
                            <MenuItem>Record not found</MenuItem>
                          )}
                        </Select>
                        <FormHelperText sx={{ color: "#d32f2f" }}>
                          {errors && errors?.productCatFamilyMappingId?.message}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        className="stepperFormInput"
                        name="brickName"
                        label="Brick Name"
                        placeholder="Enter brick name"
                        fullWidth
                        required
                        size="small"
                        autoComplete="off"
                        {...register("brickName", { required: true })}
                        error={Boolean(errors?.brickName)}
                        helperText={errors?.brickName?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("brickName", str.trim());
                         
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                    <TextField
                        className="stepperFormInput"
                        label="Brick Code"
                        name="brickCode"
                        fullWidth
                        placeholder="Enter brick code"
                        size="small"
                        required
                        autoComplete="off"
                        {...register("brickCode", { required: true })}
                        error={Boolean(errors?.brickCode)}
                        helperText={errors?.brickCode?.message}
                        onChange={() => setIsUpdateButton(false)}
                        onBlur={(e) => {
                          let str = e.target.value;
                          setValue("brickCode", str.trim());
                         
                        }}
                      />
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box sx={{ display: "flex", flexDirection: "row", p: 2, pl: 35 }}>
                <Button
                  variant="contained"
                  onClick={handleSubmit(onAddBrickSubmit)}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                  disabled={isUpdateButton && isEditMode}
                >
                  {!isEditMode ? "Save" : "Update"}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  sx={{ p: 1, mr: 1 }}
                  className="button-primary-alt-contained"
                >
                  Cancel
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AddProductBrick;
